import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import {
  MAT_PAGINATOR_DEFAULT_OPTIONS,
  MatPaginatorModule,
} from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { EditableCellWrapperComponent } from 'gain-lib/ga-table/src/ga-table/editable-cell-wrapper/editable-cell-wrapper.component';
import { MatTableWrapperComponent } from 'gain-lib/ga-table/src/ga-table/mat-table-wrapper/mat-table-wrapper.component';
import { TableErrorMessageComponent } from 'gain-lib/ga-table/src/ga-table/mat-table-wrapper/table-error-message/table-error-message.component';
import { TableZeroResultsMessageComponent } from 'gain-lib/ga-table/src/ga-table/mat-table-wrapper/table-zero-results-message/table-zero-results-message.component';
import { TableZeroResultsTitleComponent } from 'gain-lib/ga-table/src/ga-table/mat-table-wrapper/table-zero-results-title/table-zero-results-title.component';
import { GA_MAT_PAGINATOR_OPTIONS } from 'gain-lib/ga-table/src/ga-table/pagination';
import { GaIconModule } from 'gain-lib/icon';
import { GaInputFormFieldComponent } from 'gain-lib/input-form-field';
import { TableCellValueEditComponent } from 'gain-lib/table-cell-value-edit';
import { TableCellValueEditNewComponent } from 'gain-lib/table-cell-value-edit-new/src/table-cell-value-edit.component-new';
import { GATableSelectFormFieldModule } from 'gain-lib/table-select-form-field';
import { GaEditedHighlightDirective } from './ga-edited-highlight.directive';

@NgModule({
  declarations: [
    EditableCellWrapperComponent,
    GaEditedHighlightDirective,
    MatTableWrapperComponent,
    TableErrorMessageComponent,
    TableZeroResultsMessageComponent,
    TableZeroResultsTitleComponent,
  ],
  imports: [
    CommonModule,
    GaIconModule,
    GaInputFormFieldComponent,
    GATableSelectFormFieldModule,
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatSortModule,
    MatTableModule,
    NgOptimizedImage,
    TableCellValueEditComponent,
    TableCellValueEditNewComponent,
  ],
  exports: [
    EditableCellWrapperComponent,
    GaEditedHighlightDirective,
    GaIconModule,
    GaInputFormFieldComponent,
    GATableSelectFormFieldModule,
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatMenuModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    MatTableWrapperComponent,
    TableCellValueEditComponent,
    TableCellValueEditNewComponent,
    TableErrorMessageComponent,
    TableZeroResultsMessageComponent,
    TableZeroResultsTitleComponent,
  ],
  providers: [
    {
      provide: MAT_PAGINATOR_DEFAULT_OPTIONS,
      useValue: GA_MAT_PAGINATOR_OPTIONS,
    },
  ],
})
export class GaTableModule {}
